<template>
  <div class="container-fluid" :id="this.$route.name">
    <Card>
      <template slot="header">
        <h3>گردشـ حســاب</h3>
        <hr />
      </template>
      <template slot="content">
        <form>
          <div class="row" id="Filters">
            <div class="col-lg-3 col-12">
              <small :id="'Lbl' + 'tblCombogrp10state'"> نام بانک </small>
              <SearchableCombo :edit="false" :grp="29" :code="null" @ResultCombo="GetResultBank" :rownumintable="3" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'State'" :keyItem="'State'" :disabled="false"> </SearchableCombo>
            </div>
            <div class="col-lg-3 col-12">
              <small :id="'LblTarixAz'"> تاریخ گردش از </small>
              <date-picker color="dimgray" input-class="required form-control" v-model="DataAxiosFilter.ArryfildValue.tarixAz" :editable="true" placeholder=" از تاریخ "></date-picker>
            </div>
            <div class="col-lg-3 col-12">
              <small :id="'LblTariTa'">تاریخ گردش تا</small>
              <date-picker color="dimgray" v-model="DataAxiosFilter.ArryfildValue.tarixTa" :editable="true" placeholder=" تا تاریخ "></date-picker>
            </div>
            <div class="col-lg-1 col-12">
              <small id="LbltarixAz" style="white-space: nowrap"> نمایش چکها</small>
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input InputText" id="hasCheck" v-model="DataAxiosFilter.ArryfildValue.hasCheck" />
                <label class="custom-control-label" for="hasCheck"> </label>
              </div>
            </div>
            <!-- <div class="col-lg-1 col-12">
              <small id="LbltarixAz"> بدون سند</small>

              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input InputText" id="hasDocNumber" v-model="DataAxiosFilter.ArryfildValue.hasDocNumber" />
                <label class="custom-control-label" for="hasDocNumber"> </label>
              </div>
            </div> -->
            <div class="col-lg-3 col-12">
              <small id="LbltarixAz"> مبلغ گردش از</small>
              <input type="text" class="form-control text-left 3ragham" @keyup="DataAxiosFilter.ArryfildValue.MablaghAz = $PutCommatoInput_New($event)" v-model="DataAxiosFilter.ArryfildValue.MablaghAz" />
            </div>
            <div class="col-lg-3 col-12">
              <small id="LbltarixAz"> مبلغ گردش تا</small>
              <input type="text" class="form-control text-left 3ragham" @keyup="DataAxiosFilter.ArryfildValue.MablaghTa = $PutCommatoInput_New($event)" v-model="DataAxiosFilter.ArryfildValue.MablaghTa" />
            </div>
            <div class="col-lg-3 col-12"></div>
            <div class="col-lg-3 col-12">
              <button class="btn btn-success w-100" @click.prevent="BuildReport">ســاخت گزارش</button>
            </div>
          </div>
        </form>

        <div class="row">
          <div class="col-12 p-3 mt-4">
            <BnpGrid Sortable="true" v-if="$store.state.renderComponentGrid" :ListCommaReport="['Amount', 'UnAmount']" :IsReport="true" :HeaderReport="'لیست بدهکاران '" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :action="false" :SumList="['Amount', 'UnAmount']">
              <template slot="Amount" slot-scope="props">
                <span>{{ $Comma3ragham(props.props.Amount) }}</span>
              </template>
              <template slot="UnAmount" slot-scope="props">
                <span>{{ $Comma3ragham(props.props.UnAmount) }}</span>
              </template>
            </BnpGrid>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  data() {
    return {
      Column: [
        { id: 2416, name: 'CustomerCode', visibility: true, label: 'شماره مشتری' },
        { id: 2416, name: 'CustomerName', visibility: true, label: 'نام مشتری' },
        { id: 2416, name: 'Amount', visibility: true, label: 'مبلغ واریز' },
        { id: 2416, name: 'UnAmount', visibility: true, label: 'مبلغ برداشت' },
        { id: 2416, name: 'Date', visibility: true, label: ' تاریخ واریز' },
        { id: 2416, name: 'TrackingCode', visibility: true, label: 'کدرهگیری' },
        { id: 2416, name: 'NoePar', visibility: true, label: 'روش انتقال' },
        { id: 2416, name: 'Des', visibility: true, label: 'توضیحات' },
        { id: 2416, name: 'Bankname', visibility: true, label: 'بانک' },
      ],
      Rows: [],

      DataAxiosFilter: {
        Action: 'Reports/GardeshHesab',
        Method: 'POST',
        ArryfildValue: {
          tarixTa: null,
          tarixAz: null,
          bankId: null,
          MablaghTa: '',
          MablaghAz: '',
          hasCheck: true,
          hasDocNumber: true,
        },
      },
    }
  },
  components: { Card, SearchableCombo, datePicker: VuePersianDatetimePicker, BnpGrid },
  methods: {
    GetResultBank(data) {
      this.DataAxiosFilter.ArryfildValue.bankId = data.id
    },
    BuildReport() {
      if (this.$ValidForm(this.$route.name)) {
        this.$PostData(this.DataAxiosFilter).then((result) => {
          this.Rows = result.ListDeposit
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
      }
    },
  },
}
</script>
<style scoped></style>
